var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { Drawer, translate } from '@lucidlink/uicore';
import { useDrawer } from '#context';
import { CreateGuestLinkDrawer, GuestDetailsDrawer, GuestDetailsDrawerTestIdFactory, ManageGuestLinksDrawer, } from '#features/guest-links';
export const AppDrawer = ({ isInert = false }) => {
    _react_refresh_temp_2();
    const { closeDrawer, isOpen, params } = useDrawer();
    if (!isOpen) {
        return null;
    }
    switch (params.type) {
        case 'manageGuestLinks':
            return (_jsx(Drawer, { closeButtonAriaLabel: translate('Close edit guest link'), closeDrawer: closeDrawer, isInert: isInert, title: translate('Edit guest link'), children: _jsx(ManageGuestLinksDrawer, { closeDrawer: closeDrawer, params: params }) }));
        case 'createGuestLink':
            return (_jsx(CreateGuestLinkDrawer, { closeDrawer: closeDrawer, isInert: isInert, params: params }));
        case 'guestDetails':
            return (_jsx(Drawer, { closeButtonAriaLabel: translate('Close guest details'), closeDrawer: closeDrawer, "data-testid": GuestDetailsDrawerTestIdFactory.getDrawerTestId(), isInert: isInert, title: translate('Edit access for guest'), children: _jsx(GuestDetailsDrawer, { closeDrawer: closeDrawer, params: params }) }));
        default:
            return null;
    }
};
_react_refresh_temp_1 = AppDrawer;
$RefreshReg$(_react_refresh_temp_1, "AppDrawer");
_react_refresh_temp_2(AppDrawer, "/6GEdy0Hv/F/7Odpousq88HHJKM=", false, () => [useDrawer]);
